/**
 * ルート App: URL プレフィックスで 3 UI パターンに振り分ける。
 *   - `/*`              → Pattern B（本線・デフォルト）
 *   - `/__pattern-c/*`  → Pattern C（比較用アーカイブ）
 *   - `/__legacy/*`     → 現状スナップショット（2026-04 時点）
 */
import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";

const PatternBApp = lazy(() =>
  import("./patterns/pattern-b/routes").then((m) => ({ default: m.PatternBApp })),
);
const PatternCApp = lazy(() =>
  import("./patterns/pattern-c/routes").then((m) => ({ default: m.PatternCApp })),
);
const CurrentPatternApp = lazy(() =>
  import("./patterns/current/routes").then((m) => ({ default: m.CurrentPatternApp })),
);

export function App() {
  return (
    <Suspense fallback={<RootFallback />}>
      <Routes>
        <Route path="/__legacy/*" element={<CurrentPatternApp />} />
        <Route path="/__pattern-c/*" element={<PatternCApp />} />
        <Route path="/*" element={<PatternBApp />} />
      </Routes>
    </Suspense>
  );
}

function RootFallback() {
  return (
    <div className="flex h-screen items-center justify-center bg-bg-sub text-xs text-text-weak">
      読み込み中...
    </div>
  );
}
